<script setup>
import { defineProps, defineEmits, computed} from "vue";
import UtilMoney from "@/utils/UtilMoney";
import NotaFiscalService from "@/api/v2/services/NotaFiscalService";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "recebimento",
]);

const emits = defineEmits([
    "update:alteraRecebimento",
]);

//==================================================================//
//===================== Altera Recebimento =========================//
//==================================================================//

const alteraRecebimento = (update)=>{

    emits('update:alteraRecebimento',update);

};

//==================================================================//
//====================== Ao Expandir Vinculos ======================//
//==================================================================//

const aoExpandirVinculos = (aberto = false)=>{

    alteraRecebimento({
        aberto: !aberto,
    })

};

//==================================================================//
//=================== Pega Nota Fiscal Emitida =====================//
//==================================================================//

const baixarNotaFiscalEmitida = async ()=>{

    let notaFiscalResponse = await NotaFiscalService.getNotaFiscalByPlugNotasId({
        nomeArquivo: props?.recebimento?.notaFiscalEmitidaChaveAcesso,
        plugNotasId: props?.recebimento?.notaFiscalEmitidaPlugNotasID
    });
    if(notaFiscalResponse.status != "200"){
        throw new Error(`${notaFiscalResponse.message}`)
    }

};

//==================================================================//
//================== Mostra Expandir Vinculos ======================//
//==================================================================//

let mostraExpandirVinculos = computed(()=>{

    if(props?.recebimento?.vinculos?.length <= 0){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-tooltip
                    bottom
                >

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            v-show="mostraExpandirVinculos"
                            class="mx-2"
                            fab
                            dark
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoExpandirVinculos(props?.recebimento?.aberto)"
                        >

                            <v-icon
                                v-if="props?.recebimento?.aberto == false"
                                dark
                            >
                                mdi-chevron-down
                            </v-icon>

                            <v-icon
                                v-else
                                dark
                            >
                                mdi-chevron-up
                            </v-icon>

                        
                        </v-btn>

                    </template>

                    <span>Visualizar os Vinculos</span>

                </v-tooltip>

            </div>

        </div>

        <div class="c-table__cell c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    color="#dedede"
                    label
                    dark
                >

                    <v-icon left color="#565656">
                        mdi-receipt-text
                    </v-icon>

                    <span
                        class="c-table__cell-content-text"
                    >

                        {{props?.recebimento?.sequencia}}

                    </span>

                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.recebimento?.status}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            class="c-baixar-nota-fiscal-emitida mx-2"
                            fab
                            dark
                            small
                            color="#3E737B"
                            v-bind="attrs"
                            v-on="on"
                            @click="baixarNotaFiscalEmitida"
                        >

                            <v-icon dark>
                                mdi-download
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>
                        Baixar Nota Fiscal Emitida
                    </span>

                </v-tooltip>

                {{props?.recebimento?.notaFiscalEmitidaNumero}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.recebimento?.dataCriacao}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.recebimento?.valorRecebimento)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content"></div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #eeeeee;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__cell--principal{
    border-left: 10px solid #1976d2;
    border-radius: 5px;
}

.c-table__cell-content-text{
    color: #565656;
    font-weight: 600;
}

</style>
